import AnimationTimeSlider from './AnimationTimeSlider';

export default AnimationTimeSlider;
